export let defaultPackageLabels = [
  {
    label: '商品名称',
    value: 'name'
  },
  {
    label: '检测套餐',
    value: 'packages.packageName'
  }
]
